export const COMPANY_NAME = 'SOUTHERN OHIO PGA GOLF FOUNDATION';
export const COMPANY_SHORT = 'Southern Ohio PGA Foundation';
export const COMPANY_INITIALS = 'SOPGAF';
export const COMPANY_ADDRESS_FULL = 'PO BOX 340040, DAYTON, OH 45434-0040';
export const COMPANY_LOCATION = 'Dayton, Ohio';
export const MAP_URL =
  'https://www.google.com/maps/search/?api=1&query=PO%20BOX%20340040%2C%20DAYTON%2C%20OH%2045434-0040';
export const HERO_IMAGE_URL =
  'https://images.unsplash.com/photo-1587174486073-ae5e5cff23aa?auto=format&fit=crop&w=2400&q=80';
export const HERO_IMAGE_SOURCE_URL = 'https://unsplash.com/photos/green-grass-field-during-daytime-rLF8GJpsfFI';

export const PROFILE_FACTS = [
  { label: 'Mission', value: 'Junior golf & community programs' },
  { label: 'Region', value: 'Southern Ohio PGA Section' },
  { label: 'Headquarters', value: COMPANY_LOCATION },
  { label: 'Format', value: 'Charitable foundation' },
];

export const PUBLIC_INFO = [
  { label: 'Organization', value: COMPANY_NAME },
  { label: 'City / State', value: COMPANY_LOCATION },
  { label: 'Mailing Address', value: COMPANY_ADDRESS_FULL },
];

export const PROGRAM_PILLARS = [
  {
    number: '01',
    title: 'Junior Golf Development',
    body: 'A foundation profile centered on growing the game through youth participation, instruction pathways, and access in the Southern Ohio PGA region.',
  },
  {
    number: '02',
    title: 'Scholarship & Education',
    body: 'Public-facing context for awarding and supporting scholarships tied to academic and golf achievement across the section footprint.',
  },
  {
    number: '03',
    title: 'Community & Charitable Giving',
    body: 'Charitable arm framing for fundraising tournaments, member-driven outreach, and grants benefiting the local community.',
  },
  {
    number: '04',
    title: 'Section Member Support',
    body: 'Profile language reflecting support for PGA professionals, apprentices, and partners working across Southern Ohio.',
  },
];

export const COURSE_NOTES = [
  {
    tag: 'Format',
    title: 'Charitable Foundation',
    body: 'Page treats the entity as a charitable foundation rather than a commercial operation, with no transactional surfaces.',
  },
  {
    tag: 'Audience',
    title: 'Junior golfers, partners, donors',
    body: 'Plain-language profile suitable for prospective youth participants, partner clubs, and community supporters.',
  },
  {
    tag: 'Tone',
    title: 'Clubhouse editorial',
    body: 'Clubhouse-style layout: green fairway palette, brass accents, sand and cream surfaces, and quiet editorial spacing.',
  },
];
